import { render, staticRenderFns } from "./CardUserProfile.vue?vue&type=template&id=3d9ce7a6&scoped=true&"
import script from "./CardUserProfile.vue?vue&type=script&lang=js&"
export * from "./CardUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./CardUserProfile.vue?vue&type=style&index=0&id=3d9ce7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ce7a6",
  null
  
)

export default component.exports